import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Router } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router,
        private modalService: NgbModal,
        private authService: AuthenticationService) { }

    canActivate() {
        if (this.authService.isLoggedIn()) {
            return true;
        }

        this.modalService.dismissAll('');
        this.router.navigate(['/login']);
        return false;
    }
}
